export default "__VITE_ASSET__CfwPQQMq__"